import { ReactNode } from 'react';
import * as Toastify from 'react-toastify';
import Info from './toast/Info';
import Success from './toast/Success';
import Error from './toast/Error';
import Warning from './toast/Warning';
import Buy from './toast/Buy';
import Sell from './toast/Sell';
import Action from './toast/Action';

import Toast from './toast/Toast';

const toast = {
  base,
  info,
  success,
  warning,
  error,
  buy,
  sell,
  action,
  dismiss: Toastify.toast.dismiss,
};

export type ToastOptions = Toastify.ToastOptions;

type OptionsWithIcon = ToastOptions & { readonly icon?: ReactNode };

function base(children: ReactNode, options: ToastOptions = {}) {
  Toastify.toast((props) => <Toast {...props}>{children}</Toast>, options);
}

function info(children: ReactNode, options: OptionsWithIcon = {}) {
  const { icon, ...toastOptions } = options;
  Toastify.toast(
    (props) => (
      <Toast {...props}>
        <Info icon={icon}>{children}</Info>
      </Toast>
    ),
    toastOptions,
  );
}

function success(children: ReactNode, options: ToastOptions = {}) {
  Toastify.toast(
    (props) => (
      <Toast {...props}>
        <Success>{children}</Success>
      </Toast>
    ),
    options,
  );
}

function warning(children: ReactNode, options: ToastOptions = {}) {
  Toastify.toast(
    (props) => (
      <Toast {...props}>
        <Warning>{children}</Warning>
      </Toast>
    ),
    options,
  );
}

function error(children: ReactNode, options: ToastOptions = {}) {
  Toastify.toast(
    (props) => (
      <Toast {...props}>
        <Error>{children}</Error>
      </Toast>
    ),
    options,
  );
}

function buy(children: ReactNode, options: ToastOptions = {}) {
  Toastify.toast(
    (props) => (
      <Toast {...props}>
        <Buy>{children}</Buy>
      </Toast>
    ),
    options,
  );
}

function sell(children: ReactNode, options: ToastOptions = {}) {
  Toastify.toast(
    (props) => (
      <Toast {...props}>
        <Sell>{children}</Sell>
      </Toast>
    ),
    options,
  );
}

function action(children: ReactNode, options: OptionsWithIcon = {}) {
  const { icon, ...toastOptions } = options;
  Toastify.toast(
    (props) => (
      <Toast {...props}>
        <Action icon={icon}>{children}</Action>
      </Toast>
    ),
    toastOptions,
  );
}

export default toast;
